import commaNumber from 'comma-number'

const truncateDecimals = (value, precision) => {
  const [intPart, decimalPart] = String(value).split('.')
  if (!decimalPart || precision === 0) return intPart
  return `${intPart}.${decimalPart.slice(0, precision)}`
}

const formatNumber = (amount, suffix, bindWith = ', ', precision = 2) => {
  const number = Number(amount)
  const raw = truncateDecimals(number, precision)
  const format = commaNumber.bindWith(bindWith)
  return (
    <>
      {format(raw)}
      {suffix && <span style={{ marginLeft: 3 }}>{suffix}</span>}
    </>
  )
}

export default formatNumber
